var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popper',{ref:"popper",attrs:{"trigger":"clickToToggle","visible-arrow":false,"append-to-body":"","transition":"fade","enter-active-class":"fade-enter-active","leave-active-class":"fade-leave-active","options":{
    modifiers: {
      preventOverflow: {
        boundariesElement: 'window',
      },
    },
  }},on:{"show":_vm.onShow,"hide":_vm.onHide}},[_c('template',{slot:"reference"},[_vm._t("reference")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }